import api from "./api";

// Catálogo de FUNÇÕES dentro da tarefa (Edição, Motion, Captação…) — gestor/admin
// gerencia; alimenta o seletor de função ao alocar alguém no card.
// Molde: services/setores.ts.
export interface FuncaoTarefa {
  id: string;
  nome: string;
  cor: string;
  ordem: number;
  ativo: boolean;
}

export async function listarFuncoesTarefa(opts?: { todos?: boolean }) {
  const r = await api.get(`/funcoes-tarefa${opts?.todos ? "?todos=1" : ""}`);
  return r.data.data as FuncaoTarefa[];
}

export async function criarFuncaoTarefa(dados: { nome: string; cor?: string; ordem?: number }) {
  const r = await api.post("/funcoes-tarefa", dados);
  return r.data.data as FuncaoTarefa;
}

export async function atualizarFuncaoTarefa(
  id: string,
  dados: Partial<{ nome: string; cor: string; ativo: boolean; ordem: number }>,
) {
  const r = await api.patch(`/funcoes-tarefa/${id}`, dados);
  return r.data.data as FuncaoTarefa;
}

export async function excluirFuncaoTarefa(id: string) {
  await api.delete(`/funcoes-tarefa/${id}`);
}
